import script from "./CreateSupplierModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSupplierModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateSupplierModal.vue?vue&type=style&index=0&id=6df0e249&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df0e249"]])

export default __exports__